import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MedpraxNappiCodeQueryItem } from '../../types/medprax';
import { HttpApiService } from '../abstract/http/http-api.service';

@Injectable({
    providedIn: 'root'
})
export class MedpraxNappiMedicineHttpService extends HttpApiService<MedpraxNappiCodeQueryItem> {
    protected apiBasePath: string = environment.api;
    protected resourcePath: string = '/coding/medprax/nappi/medicine';
}